var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositiveCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1028,
    height: 622,
    viewBox: "0 0 1028 622",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_185_7220)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 494,
    r: 414,
    fill: "url(#paint0_linear_185_7220)",
    fillOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 466,
    r: 140.5,
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 466,
    r: 306.5,
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 514,
    cy: 466,
    r: 232.5,
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 444,
    cy: 344,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 631,
    cy: 264,
    r: 6,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_185_7220",
    x: 0,
    y: -20,
    width: 1028,
    height: 1028,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_185_7220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_7220",
    x1: 514,
    y1: 80,
    x2: 514,
    y2: 908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BEBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A0FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveCircle);
export default __webpack_public_path__ + "static/media/PositiveCircle.3f89351c0986a0b0a4c806c22d6f583f.svg";
export { ForwardRef as ReactComponent };